import Vue from "vue";
import Component from "vue-class-component";
// import AnalyticsHelper from "@Scripts/Infrastructure/AnalyticsHelper";
import ProgressHelper from "@Scripts/Infrastructure/ProgressHelper";
import LegacyFormHelper from "@Scripts/Infrastructure/LegacyFormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "InfoRequest" })
export default class InfoRequest extends Vue {
    localizer: any = Localizer;
    isLoading: boolean = false;
    isSuccess: boolean = false;
    infoRequestSubmit: any = {};
    validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    get originPage() {
        return (<any>window).App.bag.OriginPage;
    }

    async setInfoRequestSubmit() {
        this.validationErrors = [];
        this.isLoading = true;
        ProgressHelper.start();
        LegacyFormHelper.resetValidation();

        try {
            let response = await this.$store.dispatch("supportStore/infoRequestSubmit", {
                namesurname: this.infoRequestSubmit.NameSurname,
                phone: this.infoRequestSubmit.Phone,
                email: this.infoRequestSubmit.Email,
                company: this.infoRequestSubmit.Company,
                message: this.infoRequestSubmit.Message,
                isprivacypolicy: this.infoRequestSubmit.IsPrivacyPolicy,
                originpage: this.originPage,
                recaptchaResponse: (<any>window).grecaptcha.getResponse()
            });

            if (response && response.status === 200) {
                // AnalyticsHelper.sendEvent("InfoRequest", "Submit", "success");
                ProgressHelper.done();
                this.isSuccess = true;
                this.isLoading = false;
            }
        } catch (error) {
            LegacyFormHelper.resetValidation();
            this.isLoading = false;
            ProgressHelper.done();

            if (error.response) {
                if (error.response.status === 400) {
                    let validationState = error.response.data;
                    LegacyFormHelper.setValidation(validationState);

                    for (var propertyName in error.response.data) {
                        if (error.response.data.hasOwnProperty(propertyName)) {
                            for (let message of error.response.data[propertyName]) {
                                this.validationErrors.push({ message: message });
                            }
                        }
                    }
                }
            }
        }
    }

    closeModal() {
        let lgData = (<any>window).parent.lgData;
        for (let propertyName in lgData) {
            if (propertyName !== "uid" && lgData.hasOwnProperty(propertyName)) {
                if (lgData[propertyName].lGalleryOn) {
                    lgData[propertyName].destroy();
                }
            }
        }
    }
};